import UserImageData from "./user-image-data";
import { VelavuFloor } from "velavu-js-api";

export interface FloorplanImage {
	data: UserImageData;
	coords: [
		[number, number],
		[number, number],
		[number, number],
		[number, number],
	];
	opacity: number | undefined;
}

/**
 * Creates a FloorplanImage object from a VelavuFloor object, if possible.
 * Returns null if the floor does not have sufficient data to create the image.
 */
export function floorplanImageFromFloor(
	floor: VelavuFloor | null | undefined,
): FloorplanImage | null {
	if (floor && floor.img) {
		return {
			data: {
				name: floor.img.filename,
				renderable: floor.img.url,
				dimensions: {
					width: floor.img.width,
					height: floor.img.height,
				},
			},
			coords: floor.img.coordinates,
			opacity: floor.img.opacity,
		};
	} else {
		return null;
	}
}
